export default __webpack_public_path__ + "static/media/credit-card.e693a3561fa25385639eaf05444ae3af.svg";